import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProjectThread } from '../../data-models/project-thread';
import { Project } from '../../data-models/project';

import { DataService } from '../../services/data-service';
import { useStoreActions, useStoreState } from "../../store/data-store";
import ColourSwatch from '../colour-swatch/colour-swatch';
import StartProjectModal from './start-project-modal';
import CompleteProjectModal from './complete-project-modal';


const ProjectDetailsPage = () => {

    const {projectId} = useParams();

    const [project, setProject] = useState<Project>({} as Project)
    const [threads, setThreads] = useState<ProjectThread[]>([]);
    const [projectName, setProjectName] = useState(project?.name);
    const [designer, setDesigner] = useState(project?.designer);
    const [placeOfPurchase, setPlace] = useState(project?.placeOfPurchase);

    const [startModal, showStart] = useState(false);
    const [completeModal, showComplete] = useState(false);

    const user = useStoreState(store => store.user);
    const colours = useStoreState(store => store.colours);
    const inventory = useStoreState(store => store.inventory);
    const setInventory = useStoreActions( store => store.setInventory);
    const updateInventory = useStoreActions(store => store.updateInventory);
    const dataService = new DataService();
    const navigate = useNavigate();

    useEffect(() => {
        async function getProject(){
            const tokens = await dataService.getAccessToken(user);
            const project = await dataService.getProject(user.id, tokens.accessToken, Number(projectId));
            setProject(project);
            setProjectName(project.name);
            setDesigner(project.designer);
            setPlace(project.placeOfPurchase);
            setThreads(project.threads);
        }
        console.log("PROJECT ID: " + projectId);
        if( Number(projectId) > 0){
            getProject()
        }
        else {
            const newProject : Project = {
                id: 0,
                userId: '',
                name: '',
                designer: '',
                placeOfPurchase: '',
                complete: false,
                threads: []                
            }
            setProject(newProject);
            setThreads([]);
        }

    },[])

    function addThread () {
        const newThreads = [...threads, {    
            id: 0,
            projectId: project?.id,
            colourNumber: '',
            meters: 0,
            assignedMeters: 0,
            rgb: '',
            complete: false} as ProjectThread];
            setThreads(newThreads);
    }

    function handleThreadNumberChange(index:number, newNumber: string){
        const newArray = [...threads];
        const updateThread = newArray[index];
        updateThread!.colourNumber = newNumber;
        const newColour = colours.find(x => x.colourNumber.toLocaleLowerCase() === newNumber.toLocaleLowerCase());
        if( newColour !== undefined ){
            updateThread.rgb = newColour.rgb;
        }
        else {
            updateThread.rgb = "invalid";
        }
        setThreads(newArray);
    }

    function handleMetersChange(index:number, meters: number){
        const newArray = [...threads];
        const updateThread = newArray[index];
        updateThread!.meters = meters;
        setThreads(newArray);
    }
    function handleAssignedMetersChange(index:number, assignedMeters: number){
        const newArray = [...threads];
        const updateThread = newArray[index];
        updateThread!.assignedMeters = assignedMeters;
        setThreads(newArray);
    }



    function saveProject() {
        async function save(){
            if(!isProjectValid()) return;
            project!.name = projectName;
            project!.designer = designer;
            project!.placeOfPurchase = placeOfPurchase;
            project!.threads = threads;

            const tokens = await dataService.getAccessToken(user);

            await dataService.saveProject(user.id, tokens.accessToken, project!);
            const inventory = await dataService.getInventory(user.id, tokens.accessToken);
            setInventory(inventory);
    
            navigate("/projects");
        }
        save();
    }

    function back() {
        navigate("/projects");  
    }

    function toggleBobbin(colourNumber: string, newSetting:boolean){
        console.log(colourNumber);
        console.log(newSetting);
        async function updateBobbin(){
            const inv = inventory.find(x => x.colourNumber === colourNumber);
            if( inv ){
                inv.isOnBobbin = newSetting;
                
                const tokens = await dataService.getAccessToken(user);
                await dataService.updateInventoryBobbin(user.id, tokens.accessToken, inv.id, newSetting );
                updateInventory(inv);
            }
        }
        updateBobbin();
    }

    function closeModals () {
        showComplete(false);
        showStart(false);
    }

    function startProject() {
        showStart(true);
    }

    function completeProject(){
        showComplete(true);
    }

    function isProjectValid() {
        if( projectName.length === 0 || designer.length === 0 || placeOfPurchase.length === 0){
            return false;
        }
        return true;
    }

    return (
        <div className="page-section">
        <div className="action-title">
            <div className="section-title"><FontAwesomeIcon icon="chevron-left" onClick={back}/>Project Details</div>
        </div>
        { startModal && <StartProjectModal closeModal={closeModals} project={project}/> }
        { completeModal && <CompleteProjectModal closeModal={closeModals} project={project}/>}
        <div className="data-section project-details-section">
        <div className="input-field">
        <label>Project Name</label>
        <input className="form-input" value={projectName} onChange={(e)=> setProjectName(e.currentTarget.value)}/>
        </div>
        <div className="input-field">
        <label>Designer</label>
        <input className="form-input" value={designer} onChange={(e)=> setDesigner(e.currentTarget.value)}/>
        </div>
        <div className="input-field">
        <label>Place of Purchase</label>
        <input className="form-input" value={placeOfPurchase} onChange={(e)=> setPlace(e.currentTarget.value)}/>
        </div>
        <div className="input-field">
            <label>Threads<FontAwesomeIcon icon="add" onClick={addThread} title="Add a new Thread" /></label>
            <div>
                <table className="sub-table">
                    <thead>
                        <tr>
                            <th className="col-colour-number">Clr #</th>
                            <th className="col-meters">Req m</th>
                            <th className="col-meters">Asgn m</th>
                            <th></th>
                            <th></th>
                            <th>Bobbin</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            threads?.map((t, idx) =>{
                                const savedThread = t.id > 0;
                                const inventoryColour = inventory.find(x => x.colourNumber === t.colourNumber);
                                var unassignedInventory = 0;
                                let onBobbin = false;
                                if(inventoryColour){
                                    onBobbin = inventoryColour.isOnBobbin ? true : false;
                                    if( inventoryColour.assignedMeters){
                                        unassignedInventory = inventoryColour.meters - inventoryColour.assignedMeters;
                                    }
                                    else {
                                        unassignedInventory = inventoryColour.meters;
                                    }
                                }
                                return (
                                    <tr key={idx}>
                                        <td><input readOnly={savedThread} onChange={(e) => handleThreadNumberChange(idx, e.target.value)} className="form-input meters-input" value={t.colourNumber}/></td>
                                        <td><input type="number" min="0" onChange={(e) => handleMetersChange(idx, Number(e.target.value))} className="form-input meters-input" value={t.meters}/></td>
                                        <td><input type="number" min="0" max={unassignedInventory} onChange={(e) => handleAssignedMetersChange(idx, Number(e.target.value))} className="form-input meters-input" value={t.assignedMeters}/></td>
                                        <td><ColourSwatch rgb={t.rgb}/></td>
                                        <th>({unassignedInventory})</th>
                                        <th><input type="checkbox" onChange={() => toggleBobbin(t.colourNumber, !onBobbin) } checked={onBobbin}/></th>
                                    </tr>
                                )
                                })
                        }
                    </tbody>

                </table>

            </div>
        </div>
        <div className="action-section">
            <button onClick={saveProject}>Save</button>
            { project?.id > 0 && <button onClick={startProject}>Start</button> }
            { project?.id > 0 && <button onClick={completeProject}>Complete</button> }
        </div>
        </div>
        </div>
    )
}
export default ProjectDetailsPage;